import React from 'react';
import { Link } from 'react-router-dom';
import { useTranslation } from 'react-i18next';
import LandingHeader from '../Shared/LandingHeader';
import LandingFooter from '../Shared/LandingFooter';
import './FeaturesPage.css';

const FeaturesPage = () => {
    const { t } = useTranslation(['features', 'common']);
    const isLoggedIn = !!localStorage.getItem('userId');

    const featuresData = [
        {
            title: t('features:items.diagnostic.title'),
            desc: t('features:items.diagnostic.desc'),
            icon: "🔬",
            color: "#00d4ff"
        },
        {
            title: t('features:items.studyPlan.title'),
            desc: t('features:items.studyPlan.desc'),
            icon: "🗺️",
            color: "#9d50bb"
        },
        {
            title: t('features:items.microLearning.title'),
            desc: t('features:items.microLearning.desc'),
            icon: "⏱️",
            color: "#00ff88"
        },
        {
            title: t('features:items.homeworkHelper.title'),
            desc: t('features:items.homeworkHelper.desc'),
            icon: "🧠",
            color: "#ffaa00"
        },
        {
            title: t('features:items.skillScore.title'),
            desc: t('features:items.skillScore.desc'),
            icon: "📊",
            color: "#ff4444"
        },
        {
            title: t('features:items.examReadiness.title'),
            desc: t('features:items.examReadiness.desc'),
            icon: "🎯",
            color: "#ffffff"
        },
        {
            title: t('features:items.parentDashboard.title'),
            desc: t('features:items.parentDashboard.desc'),
            icon: "👨‍👩‍👧",
            color: "#00d4ff"
        },
        {
            title: t('features:items.chatMentor.title'),
            desc: t('features:items.chatMentor.desc'),
            icon: "💬",
            color: "#9d50bb"
        }
    ];

    return (
        <div className="features-page">
            <LandingHeader activePage="features" />

            <main style={{ paddingTop: '80px' }}>
                {/* Features Hero Section */}
                <section className="features-hero">
                    <div className="container">
                        <h1 className="hero-title">
                            {t('features:hero.title')} <span className="gradient-text">{t('features:hero.titleHighlight')}</span>
                        </h1>
                        <p className="hero-subtext">
                            {t('features:hero.subtext')}
                        </p>
                    </div>
                </section>

                {/* Feature Grid */}
                <section className="feature-showcase">
                    <div className="container">
                        <div className="feature-grid">
                            {featuresData.map((feature, index) => (
                                <div key={index} className="feature-card-full" style={{ '--accent': feature.color }}>
                                    <div className="feature-icon-wrapper">
                                        <span className="feature-emoji">{feature.icon}</span>
                                    </div>
                                    <h3>{feature.title}</h3>
                                    <p>{feature.desc}</p>
                                </div>
                            ))}
                        </div>
                    </div>
                </section>

                {/* How It Helps Section */}
                <section className="how-it-helps">
                    <div className="container">
                        <h2 className="section-title">{t('features:success.title')} <span className="gradient-text">{t('features:success.titleHighlight')}</span></h2>
                        <div className="comparison-grid">
                            <div className="comparison-panel">
                                <div className="panel-badge">{t('features:success.students.badge')}</div>
                                <h3>{t('features:success.students.title')}</h3>
                                <p>{t('features:success.students.text')}</p>
                            </div>
                            <div className="comparison-panel">
                                <div className="panel-badge">{t('features:success.parents.badge')}</div>
                                <h3>{t('features:success.parents.title')}</h3>
                                <p>{t('features:success.parents.text')}</p>
                            </div>
                        </div>
                    </div>
                </section>

                {/* Final CTA — hidden for logged-in users */}
                {!isLoggedIn && (
                    <section className="cta-section container">
                        <h2>{t('features:cta.title')} <span className="gradient-text">{t('features:cta.titleHighlight')}</span></h2>
                        <p>{t('features:cta.text')}</p>
                        <Link to="/demo" className="btn btn-primary">{t('features:cta.button')}</Link>
                    </section>
                )}
            </main>

            <LandingFooter />
        </div>
    );
};

export default FeaturesPage;
